import { i18n, isAuth } from 'arm-common';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AccountActions from './account/account_actions.js';

class MenuTop extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[MenuTop.jsx] ';
        this.logoutOnClick = this.logoutOnClick.bind(this);
    }

    logoutOnClick() {
        console.log(this.componentName + 'logoutOnClick');
        this.props.logoutOnClick();
    }

    render() {
        console.log(this.componentName + 'render');

        if (this.props.utente === undefined || this.props.utente === null || this.props.utente.userId === null) {
            return null;
        }

        return (
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <a className="navbar-brand" href="#/home">HOME</a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavDropdown">
                    <ul className="navbar-nav">

                        <li className="nav-item">
                            <a className="nav-link" href="#/documenti"><i className="fas fa-solid fa-folder" />{i18n('BAD.MENUTOP.DOCUMENTI', 'Documenti')}</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link" href="#/dataSource"><i className="fas fa-solid fa-database" />{i18n('BAD.MENUTOP.DATA_SOURCE', 'Data Source')}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/utilities"><i className="fas fa-cogs fa-fw" />{i18n('BAD.MENUTOP.UTILITY', 'Utilities')}</a>
                        </li>
                        {/* {isAuth('V2.ADMIN.QUEST.TAB.IMPOSTAZIONI') && */}
                            <li className="nav-item">
                                <a className="nav-link" href="#/impostazioni"><i className="fas fa-cogs fa-fw" />{i18n('BAD.MENUTOP.IMPOSTAZIONI', 'Impostazioni')}</a>
                            </li>
                        {/* // } */}
                        {isAuth('V2.ADMIN.QUEST.TAB.PROFILO') &&
                            <li className="nav-item">
                                <a className="nav-link" href="#/account/manage" title={this.props.utente.userId}><i className="fas fa-user fa-fw" />{i18n('BAD.MENUTOP.PROFILO', 'Profilo')}</a>
                            </li>
                        }
                        <li className="nav-item">
                            <a className="nav-link" href="#/logout" > <i className="fas fa-sign-out-alt fa-fw" />{i18n('BAD.MENUTOP.LOGOUT', 'Log Out')}</a>
                        </li>

                        <li className="nav-item" style={{ marginTop: "7px" }}>
                            <i className="fas fa-info-circle" style={{ fontSize: "9px", color: "rgba(0,0,0,.5)" }} title={"Version: " + this.props.version} />
                        </li>
                    </ul>
                </div>
            </nav>
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
        // logoutOnClick: function logoutOnClick() {
        //     return dispatch(AccountActions.logout());
        // },
        getVersione() {
            return dispatch(AccountActions.getVersione());
        }
    }
};

function mapStateToProps(state) {
    return {
        utente: state.account.utente,
        locate: state.app.locate,
        version: state.account.version
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MenuTop));
